module.exports = __webpack_public_path__ + "static/media/book13_happystories.1d9ade27.png";